const microBusinessQuestions = [
  // Existing questions
  {
    question:
      "Who is the person to attend the Assessment Meeting for This Business. Include all Information",
    answer: "",
    placeholder:
      "The person to attend this meeting is Mr./Miss. last name, first name. To reach them call 1-123-123-1234, their email is...",
  },
  {
    question: "What are the key challenges you face as a Micro Business?",
    answer: "",
    placeholder:
      "As a Micro Business, we face challenges such as limited resources, competition, and building brand awareness.",
  },
  {
    question:
      "Do you have a business growth plan or expansion strategy in place?",
    answer: "",
    placeholder:
      "Yes, we have a growth plan that includes opening a new location and launching an online store to reach a wider audience.",
  },
  {
    question: "How do you currently channel sales for your business?",
    answer: "",
    placeholder:
      "We primarily channel sales through our e-commerce website and also partner with local retailers.",
  },
  {
    question:
      "What are your primary business objectives for the next year? (e.g., revenue growth, market expansion, profitability improvement)",
    answer:
      "Our main goal for the next year is to achieve a 20% growth in revenue through effective market expansion strategies.",
    placeholder: "We aim to expand our market and increase revenue by X%.",
  },
  // New questions tailored for micro business
  {
    question:
      "How do you currently manage your daily operations with limited resources?",
    answer: "",
    placeholder:
      "As a micro business, we manage operations efficiently by leveraging technology and focusing on core tasks.",
  },
  {
    question:
      "What steps are you taking to ensure cost-effectiveness and profitability?",
    answer: "",
    placeholder:
      "We closely monitor expenses, negotiate with suppliers, and look for innovative ways to boost profitability.",
  },
  {
    question:
      "Do you have a unique selling proposition (USP) that sets your micro business apart?",
    answer: "",
    placeholder:
      "Our micro business stands out through personalized customer service and offering niche products.",
  },
  {
    question: "How do you plan to reach and engage your target customers?",
    answer: "",
    placeholder:
      "We utilize social media, local partnerships, and word-of-mouth to connect with our target audience.",
  },
  // ... (add more questions tailored for a micro business)
  {
    question:
      "Is there anything else you'd like to share with us that you feel is important for the growth assessment?",
    answer: "",
    placeholder:
      "We value your insights. Please feel free to share any additional information that you think is relevant for our assessment.",
  },
];

export default microBusinessQuestions;
